import { CEConstraintBase } from './ce-constraint-base'


export class CEConstraint extends CEConstraintBase {

}